import React from 'react';
import { func, bool, string } from 'prop-types';
import { Modal, notification } from 'antd';
import { Text, FlexContainer, ConfirmFooterButtons, IconContainer, Icon } from '../../common';

notification.config({
    placement: 'topRight',
    duration: 3
});

const ModalConfirmation = ({ onClose, visible, onSubmit, loading, title, msg }) => {
    return <Modal
        footer={null}
        visible={visible}
        onCancel={() => onClose()}
        style={{ width: 400 }}
    >
        <FlexContainer style={{ marginBottom: 70 }} direction='column' align='center'>
            <IconContainer color='#ffffff' size={70}>
                <Icon name='caution' color='#D60000' size={46.8} />
            </IconContainer>
            <Text text={`¿Estás seguro de ${title}?`} strong />
            <Text text={msg} />
        </FlexContainer>
        <ConfirmFooterButtons
            loading={loading}
            justify='center'
            onCancel={() => onClose()}
            confirmLabel='Aceptar'
            onConfirm={onSubmit}
            widthButtons={150}
        />
    </Modal>;
};

ModalConfirmation.propTypes = {
    onClose: func,
    visible: bool,
    onSubmit: func,
    loading: bool,
    msg: string,
    title: string
};

export default ModalConfirmation;
